import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { FormControl, Grid, Box, Typography } from '@mui/material/';

// components
import InputEmail from './InputEmail';
import AuthCodeInput from './AuthCodeInput';
import BackButton from './BackButton';
import PasswordInput from '../../components/common/PasswordInput';

// apis
import resetPasswordEmailAuthCode from '../../utils/apis/user/resetPasswordEmailAuthCodeVerify';
import resetPasswordEmailAuth from '../../utils/apis/user/resetPasswordEmailAuth';
import userChangePassword from '../../utils/apis/user/userChangePassword';

export default function FindPassword() {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const navigate = useNavigate();

  // User Email 입력 및 이메일 전송 처리 (정규식 추가예정) 23/02/02 cheol-ha
  const [userInputEmail, setUserInputEmail] = useState('');
  const [isVerifiedEmail, setIsVerifiedEmail] = useState(false);
  const [emailSendLoading, setEmailSendLoading] = useState(false);
  const [authCode, setAuthCode] = useState('');
  const [isVerifiedAuthCode, setIsVerifiedAuthCode] = useState(false);

  const [inputPW, setInputPW] = useState('');
  const [reInputPW, setReInputPW] = useState('');
  const [pwCheck, setPwCheck] = useState(false);
  const [regExp, setRegExp] = useState(false);

  // ################################# 이벤트 핸들러 Start ####################################

  // 이메일 입력
  const handleInputEmail = (e) => {
    setUserInputEmail(e.target.value);
  };

  const onChangeAuthCodeValue = (e) => {
    setAuthCode(e.target.value);
  };

  // 이메일 인증 클릭
  const ClickHandler = () => {
    if (isVerifiedAuthCode) {
      // 재인증 눌렀을 때
      setIsVerifiedEmail(false); // 이메일 입력창 활성화
      setIsVerifiedAuthCode(false);
      return;
    }
    if (!isVerifiedAuthCode && isVerifiedEmail) {
      setIsVerifiedEmail(false);
      return;
    }
    if (userInputEmail !== '') {
      resetPasswordEmailAuth(userInputEmail)
        .then((response) => {
          setEmailSendLoading(true);
          setIsVerifiedEmail(true);
          alert(t('인증번호가 발송되었습니다.'));
        })
        .catch(({ response }) => {
          const { status } = response;
          if (status === 400) alert(t('이메일 형식이 올바르지 않습니다.'));
          else if (status === 404) alert(t('가입되지않은 이메일입니다.'));
          else {
            alert('SERVER_ERROR');
          }
        })
        .finally(() => {
          setEmailSendLoading(false);
        });
    } else {
      alert(t('이메일을 입력하세요!'));
    }
  }; // 이메일 인증버튼 클릭 핸들러 END

  const onClickAuthCodeVerifyBtn = () => {
    if (authCode !== '') {
      resetPasswordEmailAuthCode({ email: userInputEmail, authCode })
        .then((res) => {
          setIsVerifiedAuthCode(true);
          alert(t('이메일 인증이 완료되었습니다.'));
        })
        .catch(({ response }) => {
          const { status } = response;
          if (status === 401) alert(t('인증번호가 일치하지 않습니다.'));
          else {
            alert('SERVER_ERROR');
          }
        });
    } else {
      alert(t('인증코드를 입력해주세요'));
    }
  };
  // 비밀번호 변경 버튼 클릭 핸들러
  const ChangeBtnClickHandler = () => {
    userChangePassword({
      userEmail: userInputEmail,
      userPassword: inputPW,
      authCode,
    })
      .then((response) => {
        alert(t('비밀번호가 변경되었습니다.'));
        navigate('/login', { replace: true });
      })
      .catch(({ response }) => {
        const { status } = response;
        if (status === 401) alert(t('인증번호가 일치하지 않습니다.'));
        alert('SERVER_ERROR');
      });
  };

  // 비밀번호 입력 핸들러
  const handleInputPW = (e) => {
    if (e.target.id === 'password') {
      setInputPW(e.target.value); // 비밀번호 입력
      const regExp = /(?=.*\d{1,50})(?=.*[~`!@#$%&*()-+=]{1,50})(?=.*[a-zA-Z]{2,50}).{8,50}$/;
      setRegExp(regExp.test(e.target.value)); // 정규식 체크
    } else if (e.target.id === 'rePassword') {
      setReInputPW(e.target.value); // 입력
      if (inputPW === e.target.value) {
        // 일치 확인
        setPwCheck(true);
      } else {
        setPwCheck(false);
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <Typography component="h1" variant="h3" style={{ marginBottom: '48px' }}>
          {t('비밀번호 찾기')}
        </Typography>

        <Box noValidate>
          <FormControl component="fieldset" variant="standard">
            <Grid container spacing={2}>
              <Grid item xs={12} style={{ marginBottom: '10px' }}>
                <InputEmail
                  initVerifyButtonText={t('인증')}
                  verifiedButtonText={t('재인증')}
                  onChange={handleInputEmail}
                  isVerifiedEmail={!!isVerifiedEmail}
                  isSendLoading={emailSendLoading}
                  onClick={ClickHandler}
                  labelText={t('이메일(아이디)')}
                />
                {isVerifiedEmail && (
                  <AuthCodeInput
                    labelText={t('인증번호 입력')}
                    verifyButtonText={t('인증')}
                    onChange={onChangeAuthCodeValue}
                    onClick={onClickAuthCodeVerifyBtn}
                    isVerifiedAuthCode={!!isVerifiedAuthCode}
                  />
                )}
              </Grid>
              {isVerifiedAuthCode && isVerifiedEmail && (
                <PasswordInput
                  passwordLabel={t('비밀번호')}
                  rePasswordLabel={t('비밀번호 확인')}
                  onChange={handleInputPW}
                  regExp={regExp}
                  regExp2={pwCheck}
                  password={inputPW}
                  rePassword={reInputPW}
                  onChangePassword={ChangeBtnClickHandler}
                  changeButtonText={t('비밀번호 변경')}
                  isFindPasswordPage
                />
              )}
            </Grid>
          </FormControl>
        </Box>
        <BackButton onClick={() => navigate(`/login`, { replace: true })} text={t('뒤로')} />
      </Box>
    </>
  );
}
